import React, { useState, useEffect } from 'react'
import { Form, Input, Button, Row, Col, Divider, message } from 'antd';
import { Link, useHistory } from 'react-router-dom';
import UserSession from '../../service/UserSession';
import { useLazyQuery } from "@apollo/react-hooks";
import { LOGIN_QUERY } from '../../constants/graphql-query';
import Captcha from '../form/Captcha';

const Login = (props) => {
  let [auth, { data }] = useLazyQuery(LOGIN_QUERY, {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  });

  const [isFormCliked, changeStatus] = useState(false)
  let history = useHistory();

  if (UserSession.getToken()) {
    history.push('/biom');
  }

  const { getFieldDecorator } = props.form;

  const handleSubmit = e => {
    e.preventDefault();
    changeStatus(!isFormCliked);
    props.form.validateFields((err, fieldsValue) => {

      if (err) {
        return;
      }
      message.loading('Authenticating.. Please wait..', 0);
      auth({
        variables: {
          logonId: fieldsValue.username,
          password: fieldsValue.password,
          isCent: true,
          isRememberMe: false,
          userTokenId: "",
          sTokenId: "",
          isEncrypted: false
        }
      })

      props.form.setFieldsValue({ "captcha": "" })
    });
  };

  const config = (input, extraRules = []) => ({
    rules: [].concat(extraRules, [{ required: true, message: `Please Enter ${input}` }]),
  });

  useEffect(() => {
    if (data && data.login) {
      if (data.login.token) {
        message.destroy();
        UserSession.setSession(data.login);
        history.push('/biom');
      } else {
        if (data.login.msg) {
          message.destroy();
          message.error(`${data.login.msg}`);
        } else {
          UserSession.clearSession()
          history.push('/login');
        }
      }
    }
  }, [data])

  return (
    <Row type="flex" align="middle" justify="center" gutter={[0, 8]} className="login-container">
      <Col span={6}>
        <Row>
          <Col span={24}>
            <h3><strong>Login</strong></h3>
          </Col>
          <Col span={24}>
            <Form layout="vertical" onSubmit={handleSubmit}>
              <Form.Item label="Username:">
                {
                  getFieldDecorator(
                    'username',
                    config(
                      'Username',
                      [{ 
                        type: "email",
                        message: 'The input is not valid E-mail!',
                      }],
                    )
                  )(<Input autoComplete="off" />)
                }
              </Form.Item>
              <Form.Item label="Password:">
                {getFieldDecorator('password', config('Password'))(<Input type="password" />)}
              </Form.Item>
              <Captcha form={props.form} isSubmitted={isFormCliked} />
              <Form.Item>
                <Link to={"/forgotPassword"}>Forgot Password ?</Link>
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit" block className="primary-dark">Login</Button>
              </Form.Item>
              {/* <Form.Item>
                                <Checkbox>
                                    <strong>
                                        Remember me on this computer
                                    </strong>
                                </Checkbox>
                            </Form.Item> */}
            </Form>
          </Col>
        </Row>
      </Col>
      <Col span={6} align="center">
        <Divider className="vertical-line" type="vertical" />
      </Col>
      <Col span={6}>
        <h3>New User Registration</h3>
        <Link to={"/register"}>
          <Button type="primary" className="primary-light">Begin My Registration</Button>
        </Link>
      </Col>
    </Row>
  )
}

const LoginForm = Form.create({ name: 'login_form' })(Login);

export default LoginForm; 